import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Util } from '@libs/utilities/util';

import { LegalCookiesBannerStorageHandler } from '../../../services/cookies-banner/cookies-storage/cookies-storage.handler';


@Component({
    selector: 'legal-cookies-usage',
    templateUrl: './cookies-usage.component.html',
    styleUrls: ['./cookies-usage.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LegalCookiesUsageComponent implements OnInit {

	//** Input decorators */
	@Input() content!: ILegalCookieUsageContent;

	//** Helpers */
	socialMediaCookies: boolean = false;
	analyticsCookies  : boolean = false;

	constructor(
		private cookiesStorageHandler: LegalCookiesBannerStorageHandler
	) {}


	ngOnInit(): void {

		// set default cookies configuration
		this.socialMediaCookies = Util.Basic.isBrowser() ? this.cookiesStorageHandler.hasAcceptedSocialMedia() : false;
		this.analyticsCookies	= Util.Basic.isBrowser() ? this.cookiesStorageHandler.hasAcceptedAnalytics() : false;
	}

	//** Save social media cookies option on change */
	saveSocialMediaOptions(allowSocialMediaCookies: boolean): void {
		this.cookiesStorageHandler.setSocialMedia(allowSocialMediaCookies);
	}

	//** Save analytical cookies option on change */
	saveAnalyticsOptions(allowAnalyticalCookies: boolean): void {
		this.cookiesStorageHandler.setAnalytics(allowAnalyticalCookies);
	}
}


//** Interfaces --------------------------------- */
export interface ILegalCookieUsageContent {
	introContent : string;
	usageContent : string;
	showSettingsDescriptions?: boolean;
}
